export const normalizeRole = (role) => (role || '').toString().trim().toLowerCase();

export const isClientRole = (role) => {
  const normalized = normalizeRole(role);
  return normalized === 'client' || normalized === 'client_user' || normalized.includes('client');
};

export const isBillingRole = (role) => normalizeRole(role) === 'billing';

export const isBillingContext = (user) => isBillingRole(user?.role) || isBillingRole(user?.organizationRole);

// OrganizationRole=Admin is a practice administrator. Only the system-admin
// persona (or an older Admin token without a context) is the global portal.
export const isGlobalAdminContext = (user) => normalizeRole(user?.contextType) === 'system-admin'
  || (!user?.contextType && normalizeRole(user?.role || user?.userRole) === 'admin');

export const isContextSelectionRequired = (user) => normalizeRole(user?.contextType) === 'selection'
  || String(user?.contextSelection).toLowerCase() === 'true';

export const isProviderRole = (role) => !isClientRole(role) && !isBillingRole(role);

export const destinationForRole = (role) => isBillingRole(role) ? '/revenue-cycle'
  : isClientRole(role) ? '/client' : normalizeRole(role) === 'admin' ? '/admin' : '/midwife';
